import { useCallback } from 'react';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import TextField from '@sdk/components/forms/TextField';
import { CurrencyType } from '@sdk/common/currency/types/CurrencyType';

type Props = {
  currency: CurrencyType;
  decimalSeparator: string;
  error?: string;
  invalid: boolean;
  isNumericString: boolean;
  name: string;
  onBlur?: () => void;
  onValueChange: (value: NumberFormatValues) => void;
  placeholder: string;
  label?: string;
  thousandSeparator: string;
  value: string;
  height: number;
};

const CurrencyField = ({ currency, ...props }: Props) => {
  // Need to override prefix, we want to use 'prefix' prop from TextField instead from NumberFormat component
  const renderTextField = useCallback(
    (props) => <TextField prefix={currency.symbol} {...props} />,
    [currency.symbol]
  );

  return <NumberFormat customInput={renderTextField} {...props} />;
};

export default CurrencyField;
